<template>
  
  <div class="font-size-adjuster">
    <span>Font Size</span>
    <div class="font-size-controls">
      <button @click="decreaseFontSize" class="font-size-btn" title="Decrease font size">
        <i class="fas fa-minus"></i>
      </button>
      <span class="font-size-display">{{ gameStore.cardHeadingFontSize }}%</span>
      <button @click="increaseFontSize" class="font-size-btn" title="Increase font size">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useGameStore } from '@/stores/gameStore';

const gameStore = useGameStore();

const decreaseFontSize = () => {
  if (gameStore.cardHeadingFontSize > 70) {
    gameStore.updateCardHeadingFontSize(gameStore.cardHeadingFontSize - 10);
  }
};

const increaseFontSize = () => {
  if (gameStore.cardHeadingFontSize < 120) {
    gameStore.updateCardHeadingFontSize(gameStore.cardHeadingFontSize + 10);
  }
};
</script>


